module.exports = __webpack_public_path__ + "static/media/select_bg.ea7debdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/AntD/assets/img/diagnostic/select_bg.png
// module id = 5084
// module chunks = 0